import script from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"

import "./AuthCallback.vue?vue&type=style&index=0&id=97ba371a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97ba371a"]])

export default __exports__